/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';
import { isNumber } from '../helper/is-number.helper';

export function validateNumber(value: any): boolean {
  return isEmpty(value) || isNumber(value);
}
